<template>
  <v-autocomplete
    v-model="selectedOrganizationId"
    auto-select-first
    dense
    item-title="description"
    item-value="_id"
    outlined
    :clearable="clearable"
    :disabled="disabled"
    :error-messages="errorMessages"
    :error="error"
    :items="items"
    :label="label"
    :loading="loading"
    :readonly="readonly"
    :rules="rules"
  >
    <template #prepend-inner>
      <organization-icon v-if="selectedOrganization" :organization="selectedOrganization" size="x-small" class="ml-n1 mr-2" />
      <!-- This happens when there is no selected organization object, but we still have an ID -->
      <organization-icon v-else :organization-id="selectedOrganizationId" size="x-small" class="ml-n1 mr-2" />
    </template>
    <template #item="{ item, props: itemProps }">
      <v-list-item v-bind="itemProps" :title="item.description" :prepend-icon="`${item.type?.toLowerCase()}`">
        <template #prepend> <organization-icon :organization="item" size="x-small" class="ml-n1 mr-2" /> </template>

        <template v-if="hasDomain" #append>
          <v-icon class="mr-2" :icon="`$domain_${item.domain?.toLowerCase()}`" />
        </template>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
const selectedOrganizationId = defineModel<string | undefined | null>()
const selectedOrganization = computed<Organization | undefined>(() => organizations.find((org) => org._id === selectedOrganizationId.value))

const {
  organizations = [],
  label = undefined,
  readonly = null,
  disabled = undefined,
  loading = undefined,
  rules = undefined,
  clearable = false,
  hasDomain = false,
  error = undefined,
  errorMessages = undefined,
} = defineProps<{
  organizations?: Array<Organization>
  label?: string
  readonly?: boolean | null
  disabled?: boolean
  loading?: boolean
  rules?: Array<(val: string | undefined | null) => boolean | string>
  clearable?: boolean
  hasDomain?: boolean
  error?: boolean
  errorMessages?: string | Array<string>
}>()

const organizationStore = useOrganizationStore()
const { organizations: allOrganizations } = storeToRefs(organizationStore)

const items = computed(() => {
  // Organization array is passed in - use it
  if (organizations.length) return organizations

  // Create new array with this specific organization
  if (selectedOrganizationId.value && !selectedOrganization.value) {
    const organization = allOrganizations.value.find((org) => org._id === selectedOrganizationId.value)
    if (!organization) return organizations

    return [organization]
  }

  return organizations
})
</script>
